// extracted by mini-css-extract-plugin
export default {"page":"catalogues-page_page__f+HCT"};